import { useEffect } from "react";
import { useBulkOperationsStore } from "../stores";
import logger from "../utils/logger";

/**
 * Custom hook to synchronize bulk device lockdown states
 *
 * Extracts lockdown state from deviceStates and maintains a separate
 * bulkDeviceLockdownStates map for bulk action UIs. Skips sync when
 * bulk status modal is open (modal tracks its own state from WebSocket events).
 *
 * @param {Object} deviceStates - Map of deviceId to device state
 * @param {boolean} isBulkStatusModalOpen - Whether bulk status modal is open
 */
export const useBulkLockdownSync = (deviceStates, isBulkStatusModalOpen) => {
  const setBulkDeviceLockdownStates = useBulkOperationsStore(
    (state) => state.setBulkDeviceLockdownStates
  );

  useEffect(() => {
    // Skip sync when modal is open - the modal tracks its own state from WebSocket events
    if (isBulkStatusModalOpen) {
      return;
    }

    const lockdownStates = {};
    let count = 0;

    Object.entries(deviceStates).forEach(([deviceId, state]) => {
      if (state && state.lockdownState) {
        lockdownStates[deviceId] = state.lockdownState;
        count++;
      }
    });

    if (count > 0) {
      logger.log(
        `[useBulkLockdownSync] 🔒 Syncing bulkDeviceLockdownStates from deviceStates: ${count} devices with lockdown state`
      );
      setBulkDeviceLockdownStates(lockdownStates);
    }
  }, [deviceStates, isBulkStatusModalOpen, setBulkDeviceLockdownStates]);
};

export default useBulkLockdownSync;
